// extracted by mini-css-extract-plugin
export default {"imgCard":"MessageImg_imgCard__UrOfH"};